export const getVideoThumbnailURL = (URL: string) => {
  if (!Boolean(URL)) {
    return;
  }

  const videoId = URL.split('/embed/')[1];
  return `https://img.youtube.com/vi/${videoId}/0.jpg`;
};
